import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function Authenticate(number,cvv){
   

    if(number.length <16 || number.length >16){
   
        toast.error('Enter a valid Card Number of 16 length', {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
        return false;
    }

    if(cvv.length <3 || cvv.length >3){
        toast.error('Enter a valid Card Cvv of 3 length', {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            });
        return false;
    }

    return true;
}

function Solve(e){
    e.preventDefault();
    let a = JSON.parse(localStorage.getItem('user'))
    const data = new FormData(e.target);
     let number = data.get('cardNumber');
     let cvv = data.get('cardCvv');

    if(Authenticate(number,cvv)){
        data.set('cardNumber','');
        data.set('cardCvv','');
    toast.success(`Thank you for purchase! ${a.name} `, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        });
    localStorage.removeItem('userCart');
    window.location = '/';
    }
    }

export default Solve;